/* eslint-disable react/require-default-props */
import React from 'react';
import styled from 'styled-components';

import { Paginate } from '@shared/Paginate';
import { RecoveryPoint } from './RecoveryPoint';
import { RecoveryPointType } from '../types';
import Button from '../../buttons/Btn';
import { Loader } from '@shared/Loader';

const Container = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;
  width: 100%;
`;

const EmptyList = styled.div`
  font-size: 18px;
  background-color: #fbe5d6;
  padding: 40px 56px;
  border-radius: 12px;
  width: 516px;

  @media (max-width: 768px) {
    width: 100%;
    padding: 24px;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 24px;
`;

type RecoveryPointsListProps = {
  points: RecoveryPointType[];
  totalPages: number;
  activePage: number;
  handlePageChange(page: number): void;
  withPagination?: boolean;
  withAdditionalInfo?: boolean;
  isPointsDataLoading?: boolean;
};

const RecoveryPointsList = ({
  points,
  totalPages,
  activePage,
  handlePageChange,
  withPagination = true,
  withAdditionalInfo = true,
  isPointsDataLoading = false,
}: RecoveryPointsListProps) => {
  if (isPointsDataLoading) {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }
  if (points.length === 0) {
    return (
      <EmptyList>
        Nous n&apos;avons pas trouvé de stage de récupération de points
        correspondant à vos critères exacts. Nous vous invitons à élargir votre
        recherche.
        <StyledButton
          text="Nouvelle recherche"
          onClick={() => {
            window.location.href = '/stage-recuperation-de-points';
          }}
        />
      </EmptyList>
    );
  }

  return (
    <Container>
      {points.map((item) => (
        <RecoveryPoint
          withAdditionalInfo={withAdditionalInfo}
          point={item}
          key={item.id}
        />
      ))}
      {withPagination && (
        <Paginate
          onPageChange={({ selected }) => {
            handlePageChange(selected + 1);
          }}
          pageCount={totalPages}
          pageRangeDisplayed={4}
          marginPagesDisplayed={1}
          initialPage={activePage - 1}
        />
      )}
    </Container>
  );
};

export { RecoveryPointsList };
